import { render } from "./BoardPagination.vue?vue&type=template&id=732005a6&scoped=true"
import script from "./BoardPagination.vue?vue&type=script&lang=js"
export * from "./BoardPagination.vue?vue&type=script&lang=js"

import "./BoardPagination.vue?vue&type=style&index=0&id=732005a6&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732005a6"]])

export default __exports__